var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { createElement, forwardRef, useMemo, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { useBlockContext, useEditor } from "./BlockEngineApi.js";
import { ChildrenBlock } from './ChildrenBlock.js';
import { useHTMLBoundary } from "./render/nodeRenderer/HTMLBoundaryNode.js";
import { shallowEqual } from './utils.js';
const DisplayFrontend = forwardRef((props, mappedRef) => {
    var _a;
    const { tag, children } = props, attributes = __rest(props, ["tag", "children"]);
    const blockContext = useBlockContext();
    if (!blockContext || !blockContext.context || !("frontend" in blockContext.context)) {
        console.error(`No frontend context found for ${(_a = blockContext === null || blockContext === void 0 ? void 0 : blockContext.Block.displayName) !== null && _a !== void 0 ? _a : "unknown block"}. If you are using the ChildrenBlockWithHTMLBoundary component, make sure to use the SmartfireBlockPageRenderer as the full page renderer.`, blockContext);
        throw new Error("No frontend context");
    }
    const node = blockContext.context.frontend.node;
    const { ref, portalNodes } = useHTMLBoundary(node, { ref: mappedRef });
    const className = useMemo(() => {
        if (!attributes.className) {
            return "smartfire-html-boundary";
        }
        if (attributes.className.includes("smartfire-html-boundary")) {
            return attributes.className;
        }
        return `${attributes.className} smartfire-html-boundary`;
    }, [attributes.className]);
    return createElement(tag !== null && tag !== void 0 ? tag : "div", Object.assign(Object.assign({}, attributes), { className,
        ref }), portalNodes.map((node, i) => {
        var _a;
        return createPortal(node.asReactElement(), (_a = node.renderingNode) !== null && _a !== void 0 ? _a : node.domNode, i.toString());
    }));
});
export const ChildrenBlockWithHTMLBoundary = forwardRef((_a, ref) => {
    var _b;
    var { gutenbergEditorConfig, childrenBlockComponent, childrenProps } = _a, otherProps = __rest(_a, ["gutenbergEditorConfig", "childrenBlockComponent", "childrenProps"]);
    const { isEditing } = useEditor();
    const mergedProps = useMemo(() => (Object.assign(Object.assign({}, otherProps), childrenProps)), [otherProps, childrenProps]);
    const [props, setProps] = useState(mergedProps);
    useEffect(() => {
        if (!shallowEqual(props, mergedProps)) {
            setProps(mergedProps);
        }
    }, [mergedProps, props]);
    if (isEditing) {
        return React.createElement(ChildrenBlock, { childrenBlockComponent: childrenBlockComponent !== null && childrenBlockComponent !== void 0 ? childrenBlockComponent : "div", gutenbergEditorConfig: gutenbergEditorConfig, childrenProps: props });
    }
    else {
        return React.createElement(DisplayFrontend, Object.assign({ tag: (_b = childrenBlockComponent) !== null && _b !== void 0 ? _b : "div" }, props, { ref: ref }));
    }
});

//# sourceMappingURL=ChildrenBlockWithHTMLBoundary.js.map
